import React, { useState, useLayoutEffect } from "react"
import NewsletterSignUp from "./NewsletterSignUp"
import Form from "./Form"
import ReactPlayer from "react-player/lazy"
import { Link, navigate } from "gatsby"
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox"

const Sidebar = (props) => {
  const { options, categories, handleSearch, handleFilter, query, forms } = props
  const [moreVideos, setMoreVideos] = useState("less")
  const [searchQuery, setSearchQuery] = useState("")
console.log('forms', forms)
  const queryLink = (event) => {
    const search = event.target.value
    setSearchQuery(search)
  }

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      navigate(`/community/?s=${event.target.value}`)
    }
  }

  useLayoutEffect(() => {
    const query = new URLSearchParams(window.location.search)
    const search = query.get("s")

    if (search) {
      setSearchQuery(search)
    }
  }, [])

  const [popup, setPopup] = useState(false)

  const handlePopup = (event) => {
    event.preventDefault();
    setPopup(!popup)
  }

  return (
    <section className="sidebar" Style="paddinleft:15px;">
	<div className="show-desktop">
	<div className="sidebarpost">
		<h2><strong>
			Have a forest you are really proud of? Tell us all about it
		</strong></h2>
		<div className="button-holder">
			<a href="#"	type="button" className="button" onClick={handlePopup}>Share Your Forest!</a>
		</div>
	</div>
	<div className="search">
          <input
            type="search"
            placeholder="Search"
            name="s"
            value={searchQuery}
            onChange={(event) => {
              handleSearch(event)
              queryLink(event)
            }}
            onKeyPress={handleKeyPress}
          />
          <Link to={`/community/?s=${searchQuery}`}>
            <svg width="40" height="40" viewBox="0 0 26 26">
              <title>lens</title>
              <g
                id="Desktop"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                <g
                  id="Community---single-page"
                  transform="translate(-1823.000000, -1091.000000)"
                  fill="#363636"
                  fillRule="nonzero"
                >
                  <g
                    id="Group-21"
                    transform="translate(1420.000000, 466.000000)"
                  >
                    <g
                      id="Group-13"
                      transform="translate(0.000000, 625.000000)"
                    >
                      <path
                        d="M428.182,23.864 L420.919,16.6 C422.379,14.844 423.258,12.59 423.258,10.129 C423.258,4.534 418.723,0 413.129,0 C407.535,0 403,4.535 403,10.129 C403,15.723 407.536,20.258 413.129,20.258 C415.591,20.258 417.845,19.379 419.6,17.919 L426.863,25.183 L428.182,23.864 L428.182,23.864 Z M404.066,10.129 C404.066,5.132 408.131,1.066 413.129,1.066 C418.126,1.066 422.192,5.132 422.192,10.129 C422.192,15.126 418.126,19.192 413.129,19.192 C408.131,19.192 404.066,15.126 404.066,10.129 Z"
                        id="lens"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </Link>
        </div>
		</div>
      <div className="subscribe">
        <h3
          dangerouslySetInnerHTML={{ __html: options.acfOptions.top.title2 }}
        ></h3>
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: options.acfOptions.top.content2 }}
        ></div>
        <NewsletterSignUp color="light" />
      </div>
      <div className="show-desktop">
        {/* <div className="widget widget-categories">
          <h3>Categories</h3>
          <ul>
            {categories &&
              categories.map((category, index) => {
                return (
                  <li key={index}>
                    <Link
                      to={`/community/?c=${category.slug}`}
                      onClick={handleFilter}
                    >
                      {category.name}
                    </Link>
                  </li>
                )
              })}
          </ul>
        </div> */}
		{/*
        <div className="widget widget-videos">
          <h3>Videos</h3>

          <div className={`widget-videos-wrap ${moreVideos}`}>
            {options.acfOptions.videos &&
              options.acfOptions.videos.map((video, index) => {
                return (
                  <div className="video-wrap" key={index}>
                    <ReactPlayer
                      url={video.videoUrl}
                      className="react-player"
                      width="100%"
                      height="100%"
                      playing={false}
                      loop={false}
                      controls={true}
                    />
                  </div>
                )
              })}
          </div>

          <div className={`button-wrap ${moreVideos}`}>
            <button className="button" onClick={() => setMoreVideos("more")}>
              view more
            </button>
          </div>
        </div>
		*/}
        <div className="widget widget-gallery">
          <h3>Showcase</h3>
          <SimpleReactLightbox>
            <SRLWrapper>
              <div className="gallery-wrap">
                {options.acfOptions.gallery &&
                  options.acfOptions.gallery.map((image, index) => {
                    let thumb = image.mediaDetails.sizes[0]

                    image.mediaDetails.sizes.map((size) => {
                      if (size.sourceUrl.includes("150x150")) {
                        thumb = size
                      }
                    })

                    return (
                      <a
                        href={image.sourceUrl}
                        key={index}
                        data-attribute="SRL"
                      >
                        <img src={thumb.sourceUrl} alt={image.altText} />
                      </a>
                    )
                  })}
              </div>
            </SRLWrapper>
          </SimpleReactLightbox>
        </div>
		{/*
        <div className="widget widget-support">
          <h3
            dangerouslySetInnerHTML={{
              __html: options.acfOptions.supportTitle,
            }}
          />
          <div
            className="content"
            dangerouslySetInnerHTML={{
              __html: options.acfOptions.supportContent,
            }}
          ></div>
          <div className="button-wrap">
            <a
              href={options.acfOptions.supportButtonUrl}
              className="button"
              dangerouslySetInnerHTML={{
                __html: options.acfOptions.supportButton,
              }}
            />
          </div>
        </div>
		*/}
      </div>

      {popup ? (
        <div className="modal modal-popup">
          <div className="modal-outside" onClick={handlePopup}></div>
          <div className="modal-wrap">
            <button className="close" onClick={handlePopup}>
              x
            </button>

            <div className="content">
              <Form forms={forms.nodes} upload="true" />
            </div>

          </div>
        </div>
      ) : null}

    </section>
  )
}

export default Sidebar
